import { Component, Input, OnInit } from '@angular/core';
import { Tooltip } from '../../../models/Tooltip';
import { newLineGreyText } from 'projects/money-movement-ui/src/app/create-request/models/form/FormControlRadio';
import { ActionCenterRedirectService } from '../../../services/ActionCenterRedirect.service';

@Component({
  standalone: false,
  selector: 'mm-control-label',
  templateUrl: './control-label.component.html',
  styleUrls: ['./control-label.component.scss']
})
export class ControlLabelComponent implements OnInit {
  @Input() controlName: string;
  @Input() label: string;
  @Input() hasError: boolean;
  @Input() hasGreyText: boolean;
  @Input() greyText: string | undefined;
  @Input() secondLineGreyText: newLineGreyText | undefined;
  @Input() displayInlineTooltip: boolean;
  @Input() displayIconTooltip: boolean;
  @Input() tooltip: Tooltip | undefined;

  constructor(private actionCenterRedirectService: ActionCenterRedirectService) { }

  ngOnInit(): void {
  }

  get hasSecondLineGreyText(): Boolean {
    return !!this.secondLineGreyText?.text.trim();
  }

  get hasSecondLineGreyTextLink(): boolean {
    return !!this.secondLineGreyText?.linkText?.trim();
  }

  onClickHyperLink(): void {
    if (this.secondLineGreyText?.linkRedirectLocation === 'actionCenter'){
      this.actionCenterRedirectService.redirectToActionCenter();
    }
  }
}
